export const prettifyPostcode = (postcode: string): string => {
    if (postcode.length > 3) {
        return postcode.slice(0, 3) + " " + postcode.slice(3);
    }
    return postcode;
};
